import { guestIdSchema, guestUid } from "@ssf/play-common";
const GUEST_ID_STORAGE_KEY = "ssf-play-guest-id";
export const getStoredGuestId = () => {
    if (typeof sessionStorage === "undefined") {
        return undefined;
    }
    const result = guestIdSchema.safeParse(sessionStorage.getItem(GUEST_ID_STORAGE_KEY));
    return result.success ? result.data : undefined;
};
export const createStoredGuestId = () => {
    const guestId = crypto.randomUUID();
    sessionStorage.setItem(GUEST_ID_STORAGE_KEY, guestId);
    return guestId;
};
export const removeStoredGuestId = () => {
    if (typeof sessionStorage !== "undefined") {
        sessionStorage.removeItem(GUEST_ID_STORAGE_KEY);
    }
};
export const getStoredGuestUid = () => {
    const guestId = getStoredGuestId();
    return guestId ? guestUid(guestId) : undefined;
};
//# sourceMappingURL=guestIdentity.js.map